import type { UIStringsOverride } from "../i18n-ui.ts";

/** Greek (el) UI strings. */
export const el: UIStringsOverride = {
  actions: {
    addToCursor: "Προσθήκη στο Cursor",
    addToVscode: "Προσθήκη στο VS Code",
    askAI: "Ρωτήστε την AI για αυτή τη σελίδα",
    connectMcp: "Σύνδεση με MCP",
    copied: "Αντιγράφηκε!",
    copyClaudeCode: "Αντιγραφή εντολής Claude Code",
    copyCode: "Αντιγραφή κώδικα",
    copyCodex: "Αντιγραφή εντολής Codex",
    copyMarkdown: "Αντιγραφή ως Markdown",
    copyServerUrl: "Αντιγραφή URL διακομιστή",
    edit: "Επεξεργασία στο GitHub",
    export: "Εξαγωγή",
    exportEpub: "Εξαγωγή σε EPUB",
    exportPdf: "Εξαγωγή σε PDF",
    generating: "Δημιουργία…",
    openIn: "Άνοιγμα στο {name}",
    openInChat: "Άνοιγμα στη συνομιλία",
    scrollToTop: "Επιστροφή στην κορυφή",
  },
  ask: {
    ai: "AI",
    clear: "Εκκαθάριση συνομιλίας",
    close: "Κλείσιμο",
    copy: "Αντιγραφή συνομιλίας",
    empty: "Κάντε μια ερώτηση σχετικά με την τεκμηρίωση.",
    error: "Λυπούμαστε, κάτι πήγε στραβά.",
    label: "Κάντε μια ερώτηση",
    placeholder: "Κάντε μια ερώτηση…",
    send: "Αποστολή",
    tip: "Συμβουλή: Μπορείτε να ανοίγετε και να κλείνετε τη συνομιλία με",
    title: "Ρωτήστε την AI",
    you: "Εσείς",
  },
  banner: { dismiss: "Κλείσιμο ανακοίνωσης" },
  changelog: {
    description: "Ενημερώσεις προϊόντος και σημειώσεις έκδοσης.",
    showReleases: "Εμφάνιση εκδόσεων {version}",
    title: "Ιστορικό αλλαγών",
  },
  content: {
    diagramError: "Δεν ήταν δυνατή η απόδοση αυτού του διαγράμματος.",
  },
  feedback: {
    no: "Όχι",
    question: "Σας φάνηκε χρήσιμη αυτή η σελίδα;",
    thanks: "Ευχαριστούμε για τα σχόλιά σας!",
    yes: "Ναι",
  },
  languageSwitcher: { label: "Γλώσσα", untranslated: "Δεν έχει μεταφραστεί" },
  nav: {
    back: "Πίσω",
    breadcrumb: "Διαδρομή πλοήγησης",
    closeNavigation: "Κλείσιμο πλοήγησης",
    deprecated: "παρωχημένο",
    featured: "Προτεινόμενα",
    githubRepository: "Αποθετήριο GitHub",
    navigation: "Πλοήγηση",
    primary: "Κύρια",
    sections: "Ενότητες",
    toggleNavigation: "Εναλλαγή πλοήγησης",
    toggleTheme: "Εναλλαγή χρωματικού θέματος",
  },
  notFound: {
    description: "Δεν μπορέσαμε να βρούμε τη σελίδα που ψάχνετε.",
    home: "Επιστροφή στην αρχική",
    title: "Η σελίδα δεν βρέθηκε",
  },
  page: {
    lastUpdated: "Τελευταία ενημέρωση",
    next: "Επόμενο",
    pagination: "Σελιδοποίηση",
    previous: "Προηγούμενο",
    skipToContent: "Μετάβαση στο περιεχόμενο",
  },
  search: {
    all: "Όλα",
    allLanguages: "Όλες οι γλώσσες",
    askAi: "Ρωτήστε την AI",
    askAiHint: "Λάβετε άμεση απάντηση από την AI",
    button: "Αναζήτηση",
    devOnly: "Η αναζήτηση είναι διαθέσιμη στην έκδοση παραγωγής.",
    error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
    label: "Αναζήτηση στην τεκμηρίωση",
    navigate: "πλοήγηση",
    noResults: "Δεν βρέθηκαν αποτελέσματα.",
    open: "άνοιγμα",
    placeholder: "Αναζήτηση στην τεκμηρίωση…",
    popular: "Δημοφιλή",
    preview: "προεπισκόπηση",
    results: "Αποτελέσματα",
  },
  toc: { title: "Σε αυτή τη σελίδα" },
};
